import { TextField } from "@mui/material";
import WrapperFilterContainer from "../../atomos/WrapperFilterContainer";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hook/store.hook";
import { getAllTemplates } from "../../../store/actions/templates.action";
import { setSearch } from "../../../store/slices/templates.slice";

const TemplateFilterController = () => {
  const dispatch = useAppDispatch();
  const { paginated, search } = useAppSelector((state) => state.templates);

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(
        getAllTemplates({
          page: paginated!.page === 0 ? 1 : paginated!.page,
          limit: paginated!.limit,
          search,
        })
      );
    }, 500); // Debounce de 500ms

    return () => clearTimeout(timer);
  }, [search, paginated, dispatch]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setSearch(e.target.value));
  };

  return (
    <WrapperFilterContainer>
      <TextField
        value={search}
        onChange={handleSearchChange}
        type="search"
        label="Buscar"
        sx={{ width: "40%" }}
      />
    </WrapperFilterContainer>
  );
};

export default TemplateFilterController;